import {bind, curry} from 'ramda';

export default function createMap() {
    const cache = new Map;
    const has = bind(cache.has, cache);
    const set = bind(cache.set, cache);
    const get = bind(cache.get, cache);
    const _delete = bind(cache.delete, cache);

    return {
        has,
        set: curry(set),
        get,
        delete: _delete,
    }
}
